import React from "react"
import styled from "@emotion/styled"

const Title = styled.h2`
  text-align: center;
  margin-bottom: 4rem;
`
const Subtitle = styled.h3`
  margin-bottom: 0.5rem;
`
const Question = styled.div``
const Questions = styled.div`
  display: grid;
  gap: 1rem;
`

const Outer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 64px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`

const Inner = styled.div`
  grid-column: 2;
  div[data-oembed] {
    position: relative;
    width: 100%;
    max-width: ${props => props.theme.maxWidthImage};
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 56.25%;
    margin-bottom: 1.666rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    max-width: ${props => props.theme.maxWidthText};
    margin-left: auto;
    margin-right: auto;
    color: #000000;
  }
  p,
  ul,
  li,
  ol {
    max-width: ${props => props.theme.maxWidthText};
    margin-left: auto;
    margin-right: auto;
    color: rgba(0, 0, 0, 0.85);
  }
  a {
    color: ${props => props.theme.primary};
  }
  pre {
    max-width: ${props => props.theme.maxWidthImage};
    margin-left: auto;
    margin-right: auto;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 8px;
    padding: 32px;
    box-sizing: border-box;
    white-space: pre-wrap;
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      word-break: break-all;
    }
  }
`

export const FaqText = () => {
  return (
    <Outer>
      <Inner>
        <Title>Your Questions Answered</Title>
        <Questions>
          <Question>
            <Subtitle>Is the Userfy process flexible?</Subtitle>
            <p>
              Yes, definitely. Depending on the stage you are already at and
              what you need, we will mix and match our capabilities to best
              suite you.
            </p>
          </Question>
          <Question>
            <Subtitle>How long does it take?</Subtitle>
            <p>
              The most focussed intense sprint from problem statement to tested
              prototype is likely to take 2 weeks, but a more complex project
              can run over a couple of months.
            </p>
          </Question>
          <Question>
            <Subtitle>How much of mine or my teams time is needed?</Subtitle>
            <p>
              This is very much down to you. We can work hand-in-hand with you
              throughout the process and workshop key steps, or you can brief us
              and let us get on, we’ll be in touch as and when needed.
            </p>
          </Question>
          <Question>
            <Subtitle>Can this be a remote process?</Subtitle>
            <p>
              Our starting point is that this entire service is delivered
              remotely.
            </p>
          </Question>
          <Question>
            <Subtitle>How much does it cost?</Subtitle>
            <p>
              We do not have a set price as this depends on the team needed to
              work on your project and your specific needs. Sometimes we will be
              asked to design a simple new feature for an existing product,
              other times a full web app from scratch.
            </p>
          </Question>
        </Questions>
      </Inner>
    </Outer>
  )
}
